import Vue from "vue";
import i18n from './i18n'
import { extend, configure, ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email, min, max, min_value, max_value } from "vee-validate/dist/rules";

extend('required', required)
extend('email', email)
extend('min', min)
extend('max', max)
extend('min_value', min_value)
extend('max_value', max_value)

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`${field}`)
    return i18n.t(`validation.${values._rule_}`, values)
  }
})


Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);